import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 flex items-center min-h-[90vh] overflow-hidden" data-id="element-310">
      {/* Background Image with Parallax */}
      <div className="absolute inset-0 z-0 scale-110" style={{
      transform: `translateY(${scrollY * 0.4}px)`
    }} data-id="element-311">
        <img src="https://cdn.rawproductionsgmbh.de/2n/home/header.jpg" alt="Zahnärztliche Fortbildung" className="w-full h-full object-cover object-center" data-id="element-312" />
        <div className="absolute inset-0 bg-[#1a1a1a]/70 mix-blend-multiply" data-id="element-313"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/40 to-transparent" data-id="element-314"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-315">
        <div className="max-w-3xl mx-auto text-center" data-id="element-316">
          <ScrollReveal variant="up" delay={100} data-id="element-317">
            <span className="inline-block py-1.5 px-4 rounded-full bg-[#59d0d4]/20 text-[#59d0d4] text-xs sm:text-sm font-extrabold tracking-wider sm:tracking-widest uppercase mb-6 border border-[#59d0d4]/30 backdrop-blur-sm" data-id="element-318">
              2N | Fortbildungsinstitut
            </span>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} data-id="element-319">
            <h1 className="text-3xl md:text-6xl lg:text-7xl text-white leading-tight mb-6 tracking-tight font-[600]" data-id="element-320">
              Akademie für zahnärztliche Fortbildung
            </h1>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={500} data-id="element-321">
            <p className="text-base sm:text-lg md:text-2xl text-slate-300 mb-10 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-322">
              Ihre Kurse & Curriculum in Bayern, Nürnberg. Praxisnahe,
              zertifizierte Weiterbildung für Zahnärzte, Oralchirurgen und
              Praxisteams.
            </p>
          </ScrollReveal>

          <ScrollReveal variant="up" delay={700} data-id="element-323">
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4" data-id="element-324">
              <a href="#kurse" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-[0_0_20px_rgba(59,119,128,0.4)]" data-id="element-325">
                Kurse entdecken
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-326" />
              </a>
              <a href="#curriculum" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-white/10 hover:bg-white/20 border border-white/30 backdrop-blur-sm transition-all hover:scale-105" data-id="element-327">
                Zum Curriculum
              </a>
              <Link to="/kontakt" className="inline-flex items-center justify-center px-6 py-3 sm:px-8 sm:py-4 text-base sm:text-lg font-bold rounded-md text-white bg-[#59d0d4] hover:bg-[#4abfc3] transition-all hover:scale-105 shadow-lg text-slate-900" data-id="element-328">
                Jetzt Kursplan sichern
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-329" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}